import {Vue} from 'ui.vue';
let alert = Vue.component('v-alert', {
	template: '<div v-if="show" class="alert" :class="type_class">' +
		'<span v-html="text"></span>' +
		'<a class="alert__close" @click="close()">Закрыть</a>' +
		'</div>',
	data: function() {
		return {
		}
	},
	props:{
		autoClose:{
			type: Boolean,
			default: true
		},
		show: {
			type: Boolean,
			default: false
		},
		type: {
			type: String,
			default:  'default'
		},
		text: {
			type: String,
			default:'Текст сообщения не определён'
		}
	},
    model: {
        prop: 'show',
        event: 'toggle'
    },
	computed: {
		type_class: function() {
			return 'alert--'+this.type
		},
	},
	methods: {
		close() {
            this.$emit('toggle',false);
        }
	},
	watch: {
        show: {
			immediate: true,
			handler: function() {
				if (!this.closed && this.autoClose) {

					setTimeout(() => {
						this.$emit('toggle',false);
						this.close()
					}, 3000)
				}
			}
		}
	}
});
export {alert}
